import React from "react";
import PropTypes from "prop-types";
import Modal from "components/Modal";
import * as inputTypes from "components/Forms/InputTypes";
import Translate from "helpers/Translate";

function AddNewInputModal({ onSelectMenu }) {
  return (
    <Modal isOpen={true} width="990px" height="450px" overflow="hidden">
      <div className="add-input-types">
        <h2>
          {Translate({ id: "select_an_input_for_your_metadata" })}
          <i
            className="far fa-times-circle pointer fr"
            title="Close"
            onClick={() => onSelectMenu(false)}
          ></i>
        </h2>

        <div className="input-collections mt-50">
          {/* Textbox */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.TEXTBOX)}
          >
            <div className="icon blue mr-10">
              <i className="fas fa-text-width"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "text" })} </div>
            <div className="description">
              {Translate({
                id: "small_or_one_liner_text_like_pan_or_aadhar_number"
              })}
            </div>
          </div>
          {/* TextArea */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.TEXTAREA)}
          >
            <div className="icon orange mr-10">
              <i className="fas fa-text-height"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "long_text" })} </div>
            <div className="description">
              {Translate({ id: "best_for_descriptions" })}{" "}
            </div>
          </div>
          {/* Number */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.NUMERIC)}
          >
            <div className="icon red mr-10">
              <i className="fab fa-draft2digital"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "number" })} </div>
            <div className="description">
              {Translate({ id: "numbers_intergers_float_decimals" })}
            </div>
          </div>
          {/* Email */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.EMAIL)}
          >
            <div className="icon green mr-10">
              <i className="fas fa-at"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "email" })} </div>
            <div className="description">
              {Translate({ id: "an_email_field_with_validation" })}{" "}
            </div>
          </div>
          {/* Radio */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.RADIOBOX)}
          >
            <div className="icon brown mr-10">
              <i className="fas fa-dot-circle"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "radio" })} </div>
            <div className="description">
              {Translate({ id: "yes_or_no_1_or_0_true_or_false" })}{" "}
            </div>
          </div>
          {/* CheckBox */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.CHECKBOX)}
          >
            <div className="icon gray mr-10">
              <i className="far fa-check-square"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "check" })} </div>
            <div className="description">
              {Translate({ id: "multiple_values_pick_multiple" })}{" "}
            </div>
          </div>
          {/* Date */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.DATESOLO)}
          >
            <div className="icon purple mr-10">
              <i className="fas fa-calendar-day"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "date" })} </div>
            <div className="description">
              {Translate({ id: "a_datepicker_with_days_months_years" })}
            </div>
          </div>
          {/* Date Range */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.DATERANGE)}
          >
            <div className="icon teal mr-10">
              <i className="fas fa-calendar-alt"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "date_range" })} </div>
            <div className="description">
              {Translate({ id: "a_datepicker_with_start_and_end_date" })}
            </div>
          </div>
          {/* Select Box */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.SELECT)}
          >
            <div className="icon violet mr-10">
              <i className="far fa-caret-square-down"></i>
            </div>
            <div className="type mr-10">{Translate({ id: "select" })} </div>
            <div className="description">
              {Translate({ id: "multiple_values_select_one" })}{" "}
            </div>
          </div>
          {/* Multi Select Box */}
          <div
            className="input-type-box"
            onClick={() => onSelectMenu(inputTypes.MULTISELECT)}
          >
            <div className="icon pink mr-10">
              <i className="fas fa-list-ul"></i>
            </div>
            <div className="type mr-10">
              {Translate({ id: "multi_select" })}{" "}
            </div>
            <div className="description">
              {Translate({ id: "multiple_values_select_multiple" })}{" "}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

AddNewInputModal.propTypes = {
  onSelectMenu: PropTypes.func.isRequired
};

export default AddNewInputModal;
